import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const Header = () => {
  // ドロップダウンの表示状態を管理
  const [dropdown, setDropdown] = useState(null);
  let timeoutId = null;

  // ハンバーガーメニュー（スマホ用）
  const [menuOpen, setMenuOpen] = useState(false);

  // ハンバーガーメニューの開閉
  const toggleMenu = () => setMenuOpen(!menuOpen);

  // 主要リンクと子リンクのデータ
  const navLinks = [
    {
      name: "企業情報",
      path: "/company",
      subLinks: [
        { name: "会社概要", path: "/company/companyOverview" },
        { name: "当社理念", path: "/company/philosophy" },
        { name: "組織図", path: "/company/organization" },
      ],
    },
    {
      name: "事業内容",
      path: "/businessContent",
      subLinks: [
        { name: "民泊運営事業", path: "/businessContent/minpaku" },
        { name: "不動産事業", path: "/businessContent/real-estate" },
      ],
    },
    { name: "お知らせ", path: "/news" },
    { name: "お問合せ・採用", path: "/contact" },
  ];

  // マウスがドロップダウン要素に入ったとき
  const handleMouseEnter = (name) => {
    clearTimeout(timeoutId); // 遅延削除をキャンセル
    setDropdown(name);
  };

  // マウスがドロップダウン要素から離れたとき
  const handleMouseLeave = () => {
    timeoutId = setTimeout(() => {
      setDropdown(null);
    }, 300); // 300ms の遅延を入れて消えないようにする
  };

  return (
    <header className="bg-white shadow-md relative z-10">
      <div className="container mx-auto px-4 flex justify-between items-center py-1">
        {/* 左側: ロゴ */}
        <div className="flex">
          <a href="/" className="flex items-center">
            <img
              src="/images/HDLogo.png"
              alt="会社ロゴ"
              className="h-16 w-auto"
            />
            <div className="text-primary">
              <p className="sm:text-sm text-xs">AHAR GROUP</p>
              <p className="sm:text-xl text-sm font-bold">アプロ山梨株式会社</p>
            </div>
          </a>
        </div>

        {/* スマホ用ハンバーガーメニュー */}
        <div className="md:hidden">
          <button onClick={toggleMenu} className="text-gray-700 focus:outline-none">
            {menuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* 右側: ナビゲーションリンク */}
        <nav className="hidden md:flex space-x-8">
          {navLinks.map((link) => (
            <div
              key={link.name}
              className="relative"
              onMouseEnter={() => handleMouseEnter(link.name)}
              onMouseLeave={handleMouseLeave}
            >
              {/* 主要リンク */}
              <a
                href={link.path}
                className="text-gray-700 hover:text-blue-500 transition-colors whitespace-nowrap"
              >
                {link.name}
              </a>

              {/* 子リンク（ドロップダウン） */}
              {link.subLinks && dropdown === link.name && (
                <div
                  className="hidden sm:block absolute top-full left-0 bg-white shadow-lg rounded-lg mt-2 py-2 w-48"
                  onMouseEnter={() => handleMouseEnter(link.name)}
                  onMouseLeave={handleMouseLeave}
                >
                  {link.subLinks.map((subLink) => (
                    <a
                      key={subLink.name}
                      href={subLink.path}
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                      {subLink.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>

      {/* スマホ用メニュー */}
      {menuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg py-2">
          {[
            { name: "企業情報", path: "/company", subLinks: [
              { name: "会社概要", path: "/company/companyOverview" },
              { name: "当社理念", path: "/company/philosophy" },
              { name: "組織図", path: "/company/organization" },
            ]},
            { name: "事業内容", path: "/businessContent", subLinks: [
              { name: "民泊運営事業", path: "/businessContent/minpaku" },
              { name: "不動産事業", path: "/businessContent/real-estate" },
            ]},
            { name: "お知らせ", path: "/news" },
            { name: "お問合せ・採用", path: "/contact" },
          ].map((link) => (
            <div key={link.name} className="border-b border-gray-200">
              <a href={link.path} className="block px-4 py-3 text-gray-700">
                {link.name}
              </a>

              {/* スマホ用ドロップダウン */}
              {link.subLinks && (
                <div className="bg-gray-100">
                  {link.subLinks.map((subLink) => (
                    <a key={subLink.name} href={subLink.path} className="block px-6 py-2 text-gray-700">
                      {subLink.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      
    </header>
  );
};

export default Header;
